// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_DentalOttonova75PlusDe = z.object({
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 120 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  phone_number: z.string().min(1).optional(),
  has_public_health_insurance: z.coerce
    .string()
    .pipe(z.enum(['true']))
    .transform(() => true)
    .optional(),
  removable_dental_prosthesis: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  periodontitis_in_last_3_years: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  not_replaced_missing_teeth_count: z.coerce
    .string()
    .pipe(z.enum(['0', '1']))
    .pipe(z.coerce.number()),
  has_other_dental_insurance_at_insurance_start: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  dental_treatment_started_planned_or_recommended: z.boolean().optional(),
})

const Schema_DentalOttonova75PlusDe = BaseSchema_DentalOttonova75PlusDe

export default Schema_DentalOttonova75PlusDe
